import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

const { semanticColors } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  container: {
    textAlign: "center",
    position: "relative",
    padding: "12px 0",
    backgroundColor: semanticColors.background.primary,
    borderTop: `1px solid ${semanticColors.border.secondary}`,
    borderBottom: `1px solid ${semanticColors.border.secondary}`,
    zIndex: 1,
    "&::before": {
      borderTop: `1px solid ${semanticColors.border.secondary}`,
      content: '""',
      margin: "0 auto",
      position: "absolute",
      top: "50%",
      left: 0,
      right: 0,
      bottom: 0,
      width: "95%",
      zIndex: -1,
    },
  },
  buttonWrapper: {
    padding: "0 16px",
    backgroundColor: semanticColors.background.primary,
    display: "inline-block",
  },
  addButton: {
    padding: 0,
    borderRadius: "4px",
    border: `1px solid ${semanticColors.foreground.action}`,
    color: semanticColors.foreground.action,
    "&:hover": {
      backgroundColor: semanticColors.background.actionLight,
    },
    "&.Mui-disabled": {
      borderColor: semanticColors.border.secondary,
      color: semanticColors.foreground.disabled,
    },
  },
});
